import { Badge } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";
import { LocationStatus } from "@models/location";

// Human label + daisyUI badge color for each location approval status (#315).
const LOCATION_STATUS_META: Record<
    LocationStatus,
    { label: string; color: ComponentColor }
> = {
    [LocationStatus.None]: { label: "—", color: ComponentColor.Ghost },
    [LocationStatus.Pending]: {
        label: "Pending",
        color: ComponentColor.Warning,
    },
    [LocationStatus.Approved]: {
        label: "Approved",
        color: ComponentColor.Success,
    },
    [LocationStatus.Rejected]: {
        label: "Rejected",
        color: ComponentColor.Error,
    },
    [LocationStatus.Suspended]: {
        label: "Suspended",
        color: ComponentColor.Neutral,
    },
    // #434: passed review, but its activation charge has not gone through.
    [LocationStatus.PendingPayment]: {
        label: "Pending payment",
        color: ComponentColor.Info,
    },
};

interface LocationStatusBadgeProps {
    status: LocationStatus;
}

export const LocationStatusBadge = ({ status }: LocationStatusBadgeProps) => {
    // A value the API sends before this enum learns it (it arrives as a bare
    // integer) has no entry: name it neutrally rather than crash the page.
    const { label, color } = LOCATION_STATUS_META[status] ?? {
        label: `Status ${status}`,
        color: ComponentColor.Neutral,
    };

    return (
        <Badge color={color} size={ComponentSize.SM}>
            {label}
        </Badge>
    );
};
